<template>
  <!-- 头部组件 -->
  <header class="header">
    <div class="header_bg">
      <div class="header_content">
        <div>
          <div>
            <el-image
              style="width: 65.9px; height: 73.8px"
              :src="require('../../assets/images/logo2x.png')"
              fit="fill"
            ></el-image>
            <span class="header_content_title"
              >普洱市科技成果转化服务平台</span
            >
          </div>
          <div class="header_content_right">
            <div class="header_content_input">
              <img
                @click="goToSelect"
                width="16"
                height="16"
                src="../../assets/images/select2x.png"
              />
              <input
                type="text"
                placeholder="搜索"
                v-model="select"
                @keyup.enter="goToSelect"
              />
            </div>
            <div>
              <div class="loginIn" v-if="isLogin">
                <div class="login_out" style="position: relative">
                  <div
                    class="logout_info"
                    @mouseout="showCert(false)"
                    @mouseover="showCert(true)"
                  >
                    <span style="display: block">用户：{{ account }}</span>
                    <div class="certific" v-show="cert">
                      <p @click="goCenter('info')">企业中心</p>
                      <p @click="goCenter('pwd')">密码修改</p>
                      <p @click="logOut()">退出</p>
                    </div>
                  </div>
                  <div
                    class="states"
                    v-show="$store.state.certificationStatus == 2"
                  >
                    <img width="15" src="../../assets/images/user/cert.png" />
                    <span>已认证</span>
                  </div>
                  <img
                    @click="showCert(true)"
                    width="15"
                    src="../../assets/images/low.png"
                  />
                </div>
              </div>
              <div class="header_content_login" v-else>
                <div @click="login()">
                  <img
                    width="16"
                    height="16"
                    src="../../assets/images/icon_user.png"
                  />
                  <span>登录</span>
                </div>
                <div @click="register()">
                  <img
                    width="16"
                    height="16"
                    src="../../assets/images/icon_user.png"
                  />
                  <span>注册</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <nav>
          <el-menu
            :router="true"
            active-text-color="#1395EE"
            :default-active="activedMenu($route.name)"
            class="el-menu-demo"
            mode="horizontal"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/techology">科技政策</el-menu-item>
            <el-menu-item index="/notice">通知公告</el-menu-item>
            <el-menu-item index="/achievements">科技成果</el-menu-item>
           <!--
            <el-menu-item index="/scienceServer">科技服务</el-menu-item>
           -->
            <el-menu-item index="/resources">资源对接</el-menu-item>
            <el-menu-item index="/talentTank">人才智库</el-menu-item>
            <!--
            <el-menu-item index="/keyEnterprises">重点企业</el-menu-item>
            -->
            <!-- <el-menu-item index="/biomedicine" style="width: 170px;">科技企业和创新平台</el-menu-item> -->
            <!-- <el-menu-item index="/innovation">科技创新</el-menu-item> -->
            <el-menu-item index="/povertyAlleviation">科技扶贫</el-menu-item>
            <el-menu-item index=""><a href="https://www.pekjzx.com/#/iframe?type=1" >特色地图</a></el-menu-item>
            <el-menu-item index="/contentDetails?id=74&type=3">关于我们</el-menu-item>

          </el-menu>
        </nav>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>{{ warning }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </header>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['certificationStatus'])
  },
  data () {
    return {
      dialogVisible: false,// 弹框显示
      warning: '认证审核中，审核时间1~3个工作日',// 弹框内容
      select: '', //搜索内容
      certificstate: 2, // 认证状态
      cert: false, //判断是否认证
      isLogin: false, // 判断是否登录
      activeIndex: '/',
      account: '' // 账号
    }
  },
  mounted () {
    let account = sessionStorage.getItem("account");
    if (account != undefined) {
      this.account = account;
      this.isLogin = true
    }
    window.addEventListener('setItem', () => {
      this.isLogin = true
      this.account = sessionStorage.getItem('account');
    })
  },
  methods: {
    //点击跳转到中心
    goCenter (type) {
      //跳转到改密码
      if (type == 'pwd')
        this.$router.push({ path: '/securityCenter' })
      else {
        if (this.certificationStatus == 2) { //已认证去企业资料
          this.$router.push({ path: '/enterpriseInfor' })
        } else {
          if (this.certificationStatus == 1) { // 待审核弹窗
            this.dialogVisible = true;
          } else { // 未认证去认证
            this.$router.push({ path: '/enterpriseCertification' })
          }
        }
      }
    },
    //快速搜索
    goToSelect () {
      this.$router.push({ path: '/notice', query: { title: this.select, type: "" } })
    },
    //跳转到企业认证
    toCertific () {
      this.$router.push({ path: '/enterpriseCertification' })
    },
    //显示企业认证
    showCert (flag) {
      this.cert = flag
      // this.cert = !this.cert
    },
    // 导航栏默认选中
    activedMenu (route) {
      if (route == 'Home') {
        return '/'
      } else
        return '/' + route;
    },
    //退出登录
    logOut () {
      this.isLogin = false;
      sessionStorage.removeItem("id");
      sessionStorage.removeItem("account")
      let router = this.$route.name;
      if (router == 'enterpriseCertification' || router.indexOf('user') == 0) {
        this.$router.push('/')
      }
    },
    login () {
      this.$router.push({ path: '/login' })
    },
    register () {
      this.$router.push({ path: '/register' })
    }
  },

}
</script>
<style scoped>
.header {
  position: relative;
  width: 100%;
  height: 163px;
  background: url("../../assets/images/bg2x.png") no-repeat;
  background-size: cover;
}
.header_bg {
  width: 1250px;
  /* width: 1180px; */
  height: 100%;
  margin: 0 auto;
  background: url("../../assets/images/tubg2x.png") no-repeat center center;
  background-size: 100% 100%;
}
.header_content {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0px auto;
  overflow: hidden;
}
.header_content > div {
  position: relative;
  width: 100%;
  margin-top: 20px;
}
.header_content > div:first-child {
  float: left;
}
.header_content > div div:first-child {
  float: left;
  /* display: flex; 
    align-items: center; */
}
.header_content_title {
  padding-left: 19px;
  line-height: 73.8px;
  font-size: 31px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: white;
}
.header_content_input {
  position: relative;
  width: 215px;
  height: 26px;
  float: left !important;
  margin-right: 31px;
  display: flex;
  align-items: center;
  border-radius: 13px;
  border: 1px solid white;
}
.header_content_input img {
  margin-left: 11px;
  cursor: pointer;
  margin-top: 5px;
  vertical-align: middle;
}
.header_content_input input {
  position: absolute;
  top: 0px;
  left: 30px;
  width: 175px;
  height: 100%;
  background: none;
  outline: none;
  border: none;
  color: white;
}
input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: white;
  font-size: 14px;
  text-align: right;
}
.header input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: white;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  text-align: right;
}
.header input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: white;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  text-align: right;
}
.header input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: white;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  text-align: right !important;
}
.header input::input-placeholder {
  text-align: right !important;
}
.header_content_right {
  height: 75px;
  float: right;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* align-items: center; */
  color: white;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
}
.header_content_login {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.header_content_login > div {
  cursor: pointer;
}
.header_content_login img {
  margin-left: 10px;
}
.header_content_login span {
  padding: 0px 19px 0px 10px;
}
.header_content_login > div:first-child {
  border-right: 1px solid white;
}
nav {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 56px;
}
.el-menu {
  position: absolute;
  bottom: 15px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  background: none;
  border: none;
}
.el-menu-item {
  width: 96px;
  height: 38px !important;
  padding: 0 0;
  margin-right: 10px;
  margin-left: 10px;
  border-radius: 19px;
  line-height: 38px;
  font-size: 16px;
  text-align: center;
  color: white !important;
  background: none;
  border: none;
}
.el-menu-item:hover {
  color: #1395ee !important;
}
.is-active {
  color: #1395ee !important;
  background-color: white !important;
  border-bottom: none !important;
}
.header /deep/ .el-menu--horizontal > .el-menu-item {
  line-height: 38px !important;
}
.header /deep/ .el-menu.el-menu--horizontal {
  border: none !important;
}
.el-menu--horizontal .el-menu-item:not(.is-active):focus {
  background-color: rgba(255, 255, 255, 0) !important;
}
/*  */
.loginIn {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: white;
}
/* .loginIn>div:first-child span{position: relative;padding-bottom: 5px;display: block;}
.loginIn>div:last-child{
    width: 99px;
    height: 48px;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: #2A45A1;
    border: 1px solid #647EE0;
} */
.certific {
  position: absolute;
  top: 20px;
  left: 0px;
  /* height: 90px;
    overflow: hidden; */
  width: 100%;
  cursor: pointer;
  /* font-size: 18px;
    line-height: 40px;
     */
  display: flex;
  flex-direction: column;
  text-align: center !important;
  background-color: white;
  color: #647ee0;
  z-index: 999;
}
.certific > p {
  font-size: 16px;
  display: block;
  border-bottom: 1px solid #647ee0;
  padding: 5px;
}
.header input {
  color: white !important;
}
.states {
  display: inline-block;
  color: #ff8400;
  padding-left: 7px;
}
.states img {
  vertical-align: middle;
}
/*  */
.login_out > img {
  padding-left: 5px;
  cursor: pointer;
  vertical-align: middle;
}
.logout_info {
  display: inline-block;
  width: auto;
  position: relative;
  height: auto;
}
.logout_info span:first-child {
  padding-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Header/Header.vue